import React, { useEffect } from "react";
import "./Eternal_Elements.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import Spiritual_Truth_Card from "./spiritual_truth_card/Spiritual_Truth_Card";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BlogCategory } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { encodeId } from "../../../utils/common";

const Eternal_Elements = () => {
  const data = [
    {
      img: "/assets/images/home/eternal_elements/img1.png",
      label: "Meditation",
    },
    {
      img: "/assets/images/home/eternal_elements/img2.png",
      label: "Kundlini",
    },
    {
      img: "/assets/images/home/eternal_elements/img3.png",
      label: "Vibrations",
    },
    {
      img: "/assets/images/home/eternal_elements/img4.png",
      label: "Pran Shakti",
    },
    {
      img: "/assets/images/home/eternal_elements/img5.png",
      label: "Maun",
    },
  ];



  const dispatch = useDispatch();
  const categories = useSelector((state) => state.common.blog_categories);

  useEffect(() => {
    dispatch(BlogCategory());
  }, [dispatch]);





  return (
    <section className="Eternal_Elements">
      <div className="container">
        <Common_Title_2
          titleText="ETERNAL ELEMENTS"
          subText="Spiritual Truth"
        />

        <div className="content_div">
          <div className="row justify-content-center">
            <div className="col-xxl-4 col-xl-4 col-md-4 col-sm-6 col-12 mb-3">
              <Spiritual_Truth_Card
                img={IDS.IMG_URL + categories[0]?.Blog_Category?.image}
                label={categories[0]?.name}
                goto={`/all-meditations?blog_category_id=${encodeId(categories[0]?.blog_category_id)}`}
              />
            </div>
            <div className="col-xxl-8 col-xl-8 col-md-8">
              <div className="row ">
                {categories?.slice(1).map((item, index) => (
                  <div
                    key={index}
                    className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-6   mb-2 custom_col"
                  >
                    <div className="grid_view">
                      <Spiritual_Truth_Card
                        img={IDS.IMG_URL + item?.Blog_Category?.image}
                        label={item?.name}
                        goto={`/all-meditations?blog_category_id=${encodeId(item?.blog_category_id)}`}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Eternal_Elements;
